import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useGeoJson } from '../state/GeojsonContext';
import config from '../config';
import { useSnackbar } from '../state/SnackbarContext';
const createGeoJSONTemplate = require('../geojsonTemplate.js')

function Element({ id, element_data }) {
    const { setGeojsonData } = useGeoJson();
    const { text, showSnackbar } = useSnackbar();

    const handleButtonClick = (groupId) => {
        const url = `${config.serverUrl}/api/element_rate/${groupId}`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const updatedData = data.map((item) => {
                    const geom_dict = JSON.parse(item.geom_geojson);
                    const geojson_geom_dict = createGeoJSONTemplate(geom_dict);
                    return { ...item, geom_geojson: geojson_geom_dict };
                });
                setGeojsonData(updatedData);
                showSnackbar(element_data.name);
            })
            .catch(error => {
                setGeojsonData(null);
                showSnackbar(element_data.name, error = true, true);
            });
    };

    const selectedElement = text === element_data.name;


    return (
        <>
            <div className={"border-bottom"} style={{ backgroundColor: selectedElement ? "#2c5a82" : "initial" }}>
                <Button onClick={() => handleButtonClick(id)} style={{
                    textAlign: 'left',
                    justifyContent: "left",
                    textWrap: "wrap",
                    fontFamily: 'Open Sans, sans-serif',
                    fontWeight: '400',
                    fontSize: "12px",
                    color: selectedElement ? "white" : "black",
                    padding: "3px 0px",
                    paddingLeft: "40px",
                    width: "100%"
                }}>
                    {element_data.name}
                </Button>
            </div >
        </>
    );
}

export default Element;